import type { RefObject } from "react";
import { useReducedMotion, useScroll, useTransform } from "framer-motion";
import { useIsMobile } from "@/hooks/use-mobile";
import { useSaveData } from "@/hooks/useSaveData";

/** Move only hero media; headings and actions stay in the normal document flow. */
export function useHeroParallax(target: RefObject<HTMLElement | null>) {
  const isMobile = useIsMobile();
  const saveData = useSaveData();
  const reducedMotion = useReducedMotion();
  const disableMotion = saveData || reducedMotion === true;
  const { scrollYProgress } = useScroll({
    target,
    offset: ["start start", "end start"],
  });
  // No spring or zoom: reversals stay tied to scroll and the original crop is preserved.
  // The image travels less than the page, so its upper edge stays above the viewport.
  const y = useTransform(
    scrollYProgress,
    [0, 1],
    ["0%", disableMotion ? "0%" : isMobile ? "12%" : "22%"],
  );

  return {
    disableMotion,
    mediaStyle: { y, willChange: disableMotion ? "auto" : "transform" },
  };
}
